import { BPReward, Reward } from '@/components/Perks/rewards/types';
import { request } from '@/utils/index';

export interface RewardsRequestsInterface {
  getRewardsRequest: () => Promise<RewardsAPICall>;
}

export interface RewardsAPICall {
  last_rev: string;
  rewards: BPReward[] | Reward[];
}

const getRewardsRequest = async () => {
  const response = await request('/rewards/index.json', {});

  if (response.rewards) {
    response.rewards.sort((a: BPReward, b: Reward) => a.order - b.order);
  }

  return response;
};

export const RewardsRequests = {
  getRewardsRequest,
};
